import { render, staticRenderFns } from "./vipdetail.vue?vue&type=template&id=6ce5626d&scoped=true&"
import script from "./vipdetail.vue?vue&type=script&lang=js&"
export * from "./vipdetail.vue?vue&type=script&lang=js&"
import style0 from "./vipdetail.vue?vue&type=style&index=0&id=6ce5626d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce5626d",
  null
  
)

export default component.exports